var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.47217,
    y: 20.5796,
    width: 3.21156,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47217,
    y: 16.3682,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47217,
    y: 87.1226,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2264,
    y: 87.1226,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2264,
    y: 16.3682,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2264,
    y: 16.3682,
    width: 3.21156,
    height: 65.5427,
    transform: "rotate(90 71.2264 16.3682)",
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2264,
    y: 87.1226,
    width: 3.21156,
    height: 65.5427,
    transform: "rotate(90 71.2264 87.1226)",
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2264,
    y: 20.5796,
    width: 3.21156,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.89526,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.526,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.39417,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5.68359,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4761,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1068,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9751,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2645,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0568,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6875,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5559,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8453,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6378,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2686,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1367,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4261,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2185,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8492,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7175,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 36.007,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7993,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4301,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2982,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5876,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3802,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 52.011,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8792,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1686,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9609,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5917,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4601,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7495,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5417,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1725,
    y: 20.5796,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0407,
    y: 20.2902,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3301,
    y: 20.5796,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47217,
    y: 95.5459,
    width: 3.21156,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47217,
    y: 91.334,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47217,
    y: 162.088,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2264,
    y: 162.088,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2264,
    y: 91.334,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2264,
    y: 91.334,
    width: 3.21156,
    height: 65.5427,
    transform: "rotate(90 71.2264 91.334)",
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2264,
    y: 162.088,
    width: 3.21156,
    height: 65.5427,
    transform: "rotate(90 71.2264 162.088)",
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2264,
    y: 95.5459,
    width: 3.21156,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 9.89526,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 6.526,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 5.39417,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 5.68359,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4761,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1068,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9751,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2645,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0568,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6875,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5559,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8453,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6378,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2686,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1367,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4261,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2185,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8492,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7175,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 36.007,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7993,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4301,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2982,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5876,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3802,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 52.011,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8792,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1686,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9609,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5917,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4601,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7495,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5417,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1725,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0407,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3301,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4379,
    y: 95.5459,
    width: 3.21156,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4379,
    y: 91.334,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4379,
    y: 162.088,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 147.192,
    y: 162.088,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 147.192,
    y: 91.334,
    width: 3.21156,
    height: 3.21156,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 146.192,
    y: 91.334,
    width: 3.21156,
    height: 65.5427,
    transform: "rotate(90 146.192 91.334)",
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 146.192,
    y: 162.088,
    width: 3.21156,
    height: 65.5427,
    transform: "rotate(90 146.192 162.088)",
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 147.192,
    y: 95.5459,
    width: 3.21156,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 84.8611,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4918,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 80.36,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6494,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 92.442,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0728,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 87.9409,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2303,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 100.023,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6533,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5217,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8112,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 107.604,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 104.234,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 103.102,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 103.392,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 115.184,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 111.815,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 110.683,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 110.973,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 122.765,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 119.396,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 118.264,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 118.554,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 130.346,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 126.977,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 125.845,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 126.134,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 137.927,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 134.557,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 133.426,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 133.715,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 145.507,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#E4E7F6",
    stroke: "#A0A0A0"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 142.138,
    y: 95.5459,
    width: 2.36925,
    height: 65.5427,
    fill: "#B4BBC9",
    stroke: "#A0A0A0"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 141.006,
    y: 95.2565,
    width: 0.421156,
    height: 66.1215,
    fill: "#7080A3",
    stroke: "#A0A0A0",
    strokeWidth: 0.421156
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 141.296,
    y: 95.5459,
    width: 3.21156,
    height: 1.52694,
    fill: "#6C6D6F",
    stroke: "#A0A0A0"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7174,
    y: 4.91016,
    width: 4.21156,
    height: 66.5427,
    transform: "rotate(12.5737 91.7174 4.91016)",
    fill: "#0080FF"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 92.6343,
    y: 0.799805,
    width: 4.21156,
    height: 4.21156,
    transform: "rotate(12.5737 92.6343 0.799805)",
    fill: "#4352CF"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2313,
    y: 69.8574,
    width: 4.21156,
    height: 4.21156,
    transform: "rotate(12.5737 77.2313 69.8574)",
    fill: "#4352CF"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 146.289,
    y: 85.2598,
    width: 4.21156,
    height: 4.21156,
    transform: "rotate(12.5737 146.289 85.2598)",
    fill: "#4352CF"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 161.692,
    y: 16.2026,
    width: 4.21156,
    height: 4.21156,
    transform: "rotate(12.5737 161.692 16.2026)",
    fill: "#4352CF"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 161.692,
    y: 16.2026,
    width: 4.21156,
    height: 66.5427,
    transform: "rotate(102.574 161.692 16.2026)",
    fill: "#0080FF"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 146.289,
    y: 85.2598,
    width: 4.21156,
    height: 66.5427,
    transform: "rotate(102.574 146.289 85.2598)",
    fill: "#0080FF"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 160.775,
    y: 20.313,
    width: 4.21156,
    height: 66.5427,
    transform: "rotate(12.5737 160.775 20.313)",
    fill: "#0080FF"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9385,
    y: 6.74414,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 99.9385 6.74414)",
    fill: "#0080FF"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 96.65,
    y: 6.00977,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 96.65 6.00977)",
    fill: "#005FFF"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 95.828,
    y: 5.82666,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 95.828 5.82666)",
    fill: "#08379F"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 95.828,
    y: 5.82666,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 95.828 5.82666)",
    fill: "#0B1D7D"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 107.338,
    y: 8.39404,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 107.338 8.39404)",
    fill: "#0080FF"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 104.049,
    y: 7.66064,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 104.049 7.66064)",
    fill: "#005FFF"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 103.227,
    y: 7.47754,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 103.227 7.47754)",
    fill: "#08379F"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 103.227,
    y: 7.47754,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 103.227 7.47754)",
    fill: "#0B1D7D"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 114.736,
    y: 10.0444,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 114.736 10.0444)",
    fill: "#0080FF"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 111.448,
    y: 9.31055,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 111.448 9.31055)",
    fill: "#005FFF"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 110.626,
    y: 9.12744,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 110.626 9.12744)",
    fill: "#08379F"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 110.626,
    y: 9.12744,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 110.626 9.12744)",
    fill: "#0B1D7D"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 122.136,
    y: 11.6948,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 122.136 11.6948)",
    fill: "#0080FF"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 118.847,
    y: 10.9614,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 118.847 10.9614)",
    fill: "#005FFF"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 118.025,
    y: 10.7778,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 118.025 10.7778)",
    fill: "#08379F"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 118.025,
    y: 10.7778,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 118.025 10.7778)",
    fill: "#0B1D7D"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 129.535,
    y: 13.3447,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 129.535 13.3447)",
    fill: "#0080FF"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 126.246,
    y: 12.6113,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 126.246 12.6113)",
    fill: "#005FFF"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 125.424,
    y: 12.4282,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 125.424 12.4282)",
    fill: "#08379F"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 125.424,
    y: 12.4282,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 125.424 12.4282)",
    fill: "#0B1D7D"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 136.934,
    y: 14.9951,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 136.934 14.9951)",
    fill: "#0080FF"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 133.645,
    y: 14.2612,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 133.645 14.2612)",
    fill: "#005FFF"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 132.823,
    y: 14.0781,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 132.823 14.0781)",
    fill: "#08379F"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 132.823,
    y: 14.0781,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 132.823 14.0781)",
    fill: "#0B1D7D"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 144.333,
    y: 16.646,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 144.333 16.646)",
    fill: "#0080FF"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 141.044,
    y: 15.9121,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 141.044 15.9121)",
    fill: "#005FFF"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 140.222,
    y: 15.7285,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 140.222 15.7285)",
    fill: "#08379F"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 140.222,
    y: 15.7285,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 140.222 15.7285)",
    fill: "#0B1D7D"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 151.732,
    y: 18.2959,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 151.732 18.2959)",
    fill: "#0080FF"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 148.443,
    y: 17.562,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 148.443 17.562)",
    fill: "#005FFF"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 147.621,
    y: 17.3789,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 147.621 17.3789)",
    fill: "#08379F"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 147.621,
    y: 17.3789,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 147.621 17.3789)",
    fill: "#0B1D7D"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 159.13,
    y: 19.9463,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 159.13 19.9463)",
    fill: "#0080FF"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 155.842,
    y: 19.2124,
    width: 3.36925,
    height: 66.5427,
    transform: "rotate(12.5737 155.842 19.2124)",
    fill: "#005FFF"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 155.02,
    y: 19.0293,
    width: 0.842312,
    height: 66.5427,
    transform: "rotate(12.5737 155.02 19.0293)",
    fill: "#08379F"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 155.02,
    y: 19.0293,
    width: 4.21156,
    height: 2.52694,
    transform: "rotate(12.5737 155.02 19.0293)",
    fill: "#0B1D7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.262cc4c12a22a5ef83e8577a97f96917.svg";
export { ForwardRef as ReactComponent };